// extracted by mini-css-extract-plugin
module.exports = {"admission":"admission_admission__3LFg2","morewrap":"admission_morewrap__1ZHWw","more":"admission_more__3YLai"};